import { FormFieldContext } from "common";
import { useField } from "formik";
import React, { useContext } from "react";
import { Tag } from "types";
import { TagInput } from "../Common/TagInput";

interface TagInputFieldProps {
    placeholder?: string;
    onChange?: (tags: Tag[]) => void;
}

export const TagInputField = ({ placeholder, onChange }: TagInputFieldProps) => {
    const name = useContext(FormFieldContext);
    const [field, , helpers] = useField(name);

    return (
        <TagInput
            value={field.value}
            placeholder={placeholder}
            onChange={(value) => {
                helpers.setValue(value);
                onChange?.(value);
            }}
        />
    );
};
